import { FirebaseDataTypes } from 'services';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState, IUser } from 'types';
import {
  GetUserPolicies,
  GetPolicyScanByUserId,
  GetNotifications,
} from 'actions';
import useFirebase from './useFirebase';

const getQuery = (userId: string, query?: string) => {
  if (!userId) {
    return '';
  }

  const baseQuery = `notifications/${userId}`;
  if (query) {
    return `${baseQuery}/${query}`;
  }

  return baseQuery;
};

const useNotifications = () => {
  const dispatch = useDispatch();
  const user = useSelector<IAppState, IUser>(R.prop('user'));
  const query = getQuery(user.id);

  const handleInsert = (data: any) => {
    if (data.type === FirebaseDataTypes.NOTIFICATION) {
      // Refresh notifications, policies and policyScans
      dispatch(GetUserPolicies(user.currentFamilyId));
      dispatch(GetPolicyScanByUserId(user.id));
      dispatch(GetNotifications());
    }
  };

  useFirebase(query, { onInsert: handleInsert });
};

export default useNotifications;
